import { API } from "./api";

/**
 * Build the URL for a diagnostic photo.
 * Cookies (httpOnly access_token) are sent automatically because the photo
 * is served from the same origin as the app via the ingress proxy.
 */
export function photoUrl(photoId, { thumb = false } = {}) {
  const base = `${API}/diagnostic-photos/${photoId}`;
  return thumb ? `${base}?thumb=true` : base;
}

export const REPORT_STATUS_LABEL = {
  draft: "Draft",
  submitted: "Submitted",
  finalized: "Finalized",
};

export const REPORT_STATUS_TINT = {
  draft: "bg-slate-100 text-slate-700 border-slate-300",
  submitted: "bg-amber-100 text-amber-900 border-amber-300",
  finalized: "bg-emerald-100 text-emerald-800 border-emerald-300",
};
